import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Tooltip } from '@mui/material';
import { IconChevronDown } from '@shared/assets/images/svgs';

import { AgentProfileResponseDto } from '@shared/services/apiService';

import { useStyles } from './styles';

interface RolePickerTriggerProps {
  selected: AgentProfileResponseDto | null | undefined;
  open: boolean;
  error?: boolean;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const RolePickerTrigger = forwardRef<HTMLButtonElement, RolePickerTriggerProps>(
  ({ selected, open, error = false, disabled, onClick }, ref) => {
    const { classes } = useStyles();
    const { t } = useTranslation();

    const isPlaceholder = !selected || !selected.name;
    const labelText = isPlaceholder
      ? (t('campaignPage.placeholders.profileType') as string)
      : selected.name;

    return (
      <Tooltip title={isPlaceholder ? '' : selected.name} arrow placement="top" disableInteractive>
        <button
          ref={ref}
          type="button"
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-label={t('campaignPage.profilePicker.triggerAriaLabel') as string}
          disabled={disabled}
          onClick={onClick}
          className={classNames(classes.trigger, {
            [classes.triggerOpen]: open,
            [classes.triggerError]: error,
          })}>
          <span
            className={classNames(classes.triggerLabel, {
              [classes.triggerPlaceholder]: isPlaceholder,
            })}>
            {labelText}
          </span>
          <span
            className={classNames(classes.triggerChevron, {
              [classes.triggerChevronOpen]: open,
            })}
            aria-hidden="true">
            <IconChevronDown />
          </span>
        </button>
      </Tooltip>
    );
  },
);

RolePickerTrigger.displayName = 'RolePickerTrigger';
